import script from "./color-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-picker.vue?vue&type=script&setup=true&lang=ts"

import "./color-picker.vue?vue&type=style&index=0&id=72579bd4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72579bd4"]])

export default __exports__